import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import ApolloClient, { createNetworkInterface } from 'apollo-client';
import exhibitorsFilterSelector from './exhibitorsFilterSelector';
import mediaPartnersFilterSelector from './mediaPartnersFilterSelector';
import roundTablesFilterSelector from './roundTablesFilterSelector';
import personalitiesFilterSelector from './personalitiesFilterSelector';
import dateSelector from './dateSelector';
import localeSelector from './localeSelector';
import menuToggler from './menuToggler';

const client = new ApolloClient({
  // networkInterface: createNetworkInterface('http://localhost:8081'),
  networkInterface: createNetworkInterface('http://gql.futurecom.com.br/graphql'),
});

const rootReducer = combineReducers({
  exhibitorsFilterSelector,
  mediaPartnersFilterSelector,
  roundTablesFilterSelector,
  personalitiesFilterSelector,
  dateSelector,
  localeSelector,
  menuToggler,
  routing: routerReducer,
  apollo: client.reducer(),
});

export { rootReducer, client };



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/